/*
 * SUM-RETENTION-AMOUNT.JS - Retention Amount Calculation Utility for Progress Claims
 * 
 * SUMMARY:
 * A utility function that calculates the total retention amounts and claim amounts
 * for a specific project, excluding the current progress claim being processed.
 * Used in preview-budget functionality to determine retention calculations.
 */

const { getAllProgressClaimList } = require("../../../../../../actions/project-management.action");

/**
 * Calculates cumulative retained and claimed amounts across historical progress claims.
 * Reuses existing in-memory progressClaims if provided to eliminate redundant network calls.
 *
 * @param {Object} params - Calculation parameters
 * @param {Array<Object>} [params.progressClaims] - Pre-fetched array of progress claims
 * @param {string} [params.projectId] - Project UUID (used as fallback if progressClaims not provided)
 * @param {string|number} [params.progressClaimId] - Current claim ID to exclude in edit mode
 * @param {Function} [params.dispatch] - Redux dispatch function (used for fallback fetch)
 * @returns {Promise<{ claimsRetainedTotal: number, claimsRetentionClaimTotal: number }>} Cumulative totals
 */
export const sumRetentionAmount = async ({ progressClaims, projectId, progressClaimId, dispatch }) => {
    let claimsRetainedTotal = 0; // total retained to date (sum of retentions withheld)
    let claimsRetentionClaimTotal = 0; // total of all previous claims (sum of claim amounts)

    let claims = progressClaims;
    if (!Array.isArray(claims) && projectId && dispatch) {
        claims = await dispatch(getAllProgressClaimList(projectId)).catch(e => console.log(e));
    }

    if (Array.isArray(claims)) {
        claims.forEach((claim) => {
            const isCurrentClaim = progressClaimId && (claim.id == progressClaimId || claim.u_id === progressClaimId);
            if (!isCurrentClaim) {
                claimsRetainedTotal += parseFloat(claim.retentionAmount || 0);
                // Claimed Amount should be total of all previous claims
                claimsRetentionClaimTotal += parseFloat(claim.claimAmount || 0);
            }
        });
    }
    return { claimsRetainedTotal, claimsRetentionClaimTotal };
};